/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ selected: NonNullable<unknown>, total: NonNullable<unknown> }} Table_Rows_SelectedInputs */

const en_table_rows_selected = /** @type {(inputs: Table_Rows_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} row(s) selected.`)
};

const es_table_rows_selected = /** @type {(inputs: Table_Rows_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} de ${i?.total} filas seleccionadas.`)
};

/**
* | output |
* | --- |
* | "{selected} of {total} row(s) selected." |
*
* @param {Table_Rows_SelectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const table_rows_selected = /** @type {((inputs: Table_Rows_SelectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Rows_SelectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_rows_selected(inputs)
	return es_table_rows_selected(inputs)
});